<template>
    <v-container fluid>
        <comp-playback :device_id="device_id" :target_date="targetDate" />
        <div class="pt-5">
            <v-data-table hide-default-footer :headers="tblHeader" :items="sparkline" mobile-breakpoint="0" class="elevation-5" multi-sort dense>
                <!--
                <template v-slot:[`item.date`]="{ item }">
                    <v-btn class="pa-0" color="primary" small text :to="{ name: 'Playback', params: { device_id: dbDevice.id, target_date: item.date } }">{{ item.date }}</v-btn>
                </template>
                -->
                <template v-slot:[`item.date`]="{ item }">
                    <v-btn color="primary" small text @click="targetDate = item.date" class="subtitle-1">{{ item.date }}</v-btn>
                </template>

                <template v-slot:[`item.shot`]="{ item }">
                    <v-progress-linear class="ma-2" height="15" :value="item['shot']" color="pink lighten-3" @click="targetDate = item.date">
                        <h4>{{ item["shot"] }}</h4>
                    </v-progress-linear>
                </template>
            </v-data-table>
        </div>
    </v-container>
</template>

<script>
import compPlayback from "@/components/CompPlayback";
import JWT from "jsonwebtoken";
export default {
    name: "Dashboard",
    //#######################################################
    components: {
        compPlayback,
    },
    //#######################################################
    props: {
        device_id: {
            type: Number,
            required: true,
        },
        target_date: {
            type: String,
            required: true,
        },
    },
    //#######################################################
    data() {
        return {
            jwt: "",
            myInfo: [],
            targetDate: this.$moment().format("YYYY-MM-DD"),
            dbDevice: {},
            dbShotLogs: [],
            sparkline: [],
            tblHeader: [
                { divider: true, class: "blue darken-1 white--text", align: "center", width: "130", text: "日付", value: "date" },
                { divider: true, class: "blue darken-1 white--text", align: "center", width: null, text: "画像枚数", value: "shot" },
            ],
            isLoading: false,
        };
    },
    //#######################################################
    created: async function () {
        this.jwt = this.$localStorage.get("user-jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return true;
        }
        this.myInfo = JWT.decode(this.jwt);
        if (this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return true;
        }
        //---------------------------------
        //this.device_id = this.$route.params.device_id;
        //---------------------------------
        this.isLoading = true;
        //---------------------------------
        const promiseDevices = this.axiosGetDevices();
        const promiseShotLogs = this.axiosGetShotLogs();
        await promiseDevices;
        await promiseShotLogs;
        this.createSparkLineData();
        await new Promise((r) => setTimeout(r, 1000));
        this.isLoading = false;
        window.scrollTo(0, 0);
    },
    //#######################################################
    mounted: function () {},
    //#######################################################
    methods: {
        //====================================================
        async axiosGetDevices() {
            await this.axios({
                method: "GET",
                url: "/web/api/devices",
                params: {
                    id: this.device_id,
                    "_order[sort_no]": "asc",
                },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 10000,
            }).then((response) => {
                if (response.data.json[0]) {
                    this.dbDevice = response.data.json[0];
                }
            });
        },
        //====================================================
        async axiosGetShotLogs() {
            //----------------------------------
            let sdate = this.$moment(this.target_date).add(-10, "days").format("YYYY-MM-DD");
            let edate = this.$moment(this.target_date).add(1, "days").format("YYYY-MM-DD");
            //----------------------------------
            await this.axios({
                method: "GET",
                url: "/web/api/shot_logs",
                headers: { Authorization: "Bearer " + this.jwt },
                params: {
                    device_id: this.device_id,
                    _fields: "device_id,received_at",
                    "received_at[EQGREAT]": sdate,
                    "received_at[SMALL]": edate,
                },
                timeout: 10000,
            }).then((response) => {
                this.dbShotLogs = response.data.json;
            });
            //-------------------------------
        },
        //====================================================
        createSparkLineData() {
            //-------------------------------------------
            let shotCount = {};
            for (let obj of this.dbShotLogs) {
                const device_id = obj.device_id;
                if (!shotCount[device_id]) {
                    shotCount[device_id] = {};
                    for (let i = 0; i < 10; i++) {
                        const received = this.$moment(this.target_date)
                            .add(i * -1, "days")
                            .format("YYYY-MM-DD");
                        shotCount[device_id][received] = 0;
                    }
                }
                const received = this.$moment(obj.received_at).format("YYYY-MM-DD");
                if (!shotCount[device_id][received]) {
                    shotCount[device_id][received] = 0;
                }
                shotCount[device_id][received] += 1;
            }
            //-------------------------------------------
            let device_id = this.dbDevice["id"];
            this.sparkline = [];
            for (let i = 0; i < 10; i++) {
                const received = this.$moment(this.target_date)
                    .add(i * -1, "days")
                    .format("YYYY-MM-DD");
                const ct = shotCount[device_id] && shotCount[device_id][received] ? shotCount[device_id][received] : 0;
                this.sparkline.push({
                    date: received,
                    shot: ct,
                });
            }
        },
        //====================================================
    },
    //#######################################################
};
</script>
